<template>
  <div>
    <div>
      <documents-list
        :resource-id="$store.getters['drivers/currentDriver'].carId"
        resource-type="car"
      />

    </div>
  </div>
</template>

<script>
import DocumentsList from '@/views/driver/documents/DocumentsList.vue'
import useDocumentsList from '@/views/driver/documents/useDocumentsList'
import store from '@/store'

export default {
  components: {
    DocumentsList,
  },
  setup() {
    const { fetchDocuments } = useDocumentsList()
    fetchDocuments('car', store.getters['drivers/currentDriver'].carId)
    return {
      fetchDocuments,
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
